/**
 * Métodos especificos para o modo Server
 * @type {Object}
 */
MdHub.server = {
  /**
   * Flag para controle se os eventos foram iniciados.
   */
  bindEventsAlreadyRan: false,

  /**
   * Callback para registrar o evento de message. Necessário para funcionar no IE8
   */
  registerEventMessage: function registerEventMessage(messageData) {
    MdHub.postMessage.receive(messageData);
  },

  /**
   * Callback para enviar um evento de mudança de Location Hash
   */
  registerEventHashchange: function registerEventHashchange() {
    MdHub.event.trigger('core:hashChange', window.location.hash);
  },

  /**
   * Inicia os eventos padrões para o modo Server
   */
  bindEvents: function bindEvents() {
    // Precisa ter function no listener abaixo para funcionar no IE8
    window.addEventListener('message', this.registerEventMessage, false);

    // Mudança de Location Hash
    window.addEventListener('hashchange', this.registerEventHashchange, false);

    if (this.bindEventsAlreadyRan) {
      return;
    }

    this.bindEventsAlreadyRan = true;

    // Eventos
    MdHub.event.add('core:moduleInit', function moduleInit(data) {
      MdHub.module.init(data);
    });

    // Comandos

    // Retorna a apikey
    MdHub.command.add('core:getApiKey', function getApiKey(data, resolve) {
      resolve(MdHub.options.apiKey);
    });

    // Retorna as environments dos ambientes
    MdHub.command.add('core:getEnvironment', function getEnvironment(moduleName, resolve) {
      var moduleEnv = MdHub.getEnvironments();
      if (moduleEnv) {
        return resolve(moduleEnv);
      }
      return resolve({});
    });

    // Retorna termos do dicionario
    MdHub.command.add('core:getDictionary', function getDictionary(data, resolve) {
      resolve(MdHub.dict.getAll());
    });

    // Retorna os dados da localização da janela principal
    MdHub.command.add('core:getLocation', function getLocation(data, resolve) {
      resolve({
        hash: window.location.hash,
        host: window.location.host,
        hostname: window.location.hostname,
        href: window.location.href,
        origin: window.location.origin,
        pathname: window.location.pathname,
        port: window.location.port,
        protocol: window.location.protocol
      });
    });

    // Retorna o location hash da janela principal
    MdHub.command.add('core:getLocationHash', function getLocationHash(data, resolve) {
      resolve(window.location.hash);
    });

    // Comando para pegar os módulos que estão sendo mostrados
    MdHub.command.add('core:getModulesShowing', function moduleShow(data, resolve) {
      resolve({ modules: Object.getOwnPropertyNames(MdHub.module.listShowing) });
    });

    MdHub.command.add('core:getOptions', function getUsuario(data, resolve) {
      resolve(MdHub.options);
    });

    // Adiciona comando para recuperação de dependencias
    MdHub.command.add('core:getRequire', MdHub.module.getRequire);

    // Comando para verificar se o módulo está sendo mostrado
    MdHub.command.add('core:isModuleShowing', function moduleShow(data, resolve) {
      resolve(Object.prototype.hasOwnProperty.call(MdHub.module.listShowing, data));
    });

    // Comando para mostrar um módulo
    MdHub.command.add('core:moduleShow', function moduleShow(data, resolve) {
      MdHub.module.show(data);
      resolve();
    });

    // Comando para esconder um módulo
    MdHub.command.add('core:moduleHide', function moduleHide(data, resolve) {
      MdHub.module.hide(data);
      resolve();
    });

    // Altera termos do dicionario
    MdHub.command.add('core:setDictionary', function setDictionary(data, resolve) {
      resolve(MdHub.dict.set(data));
    });

    // Altera as propriedades da localização da janela principal
    MdHub.command.add('core:setLocation', function setLocation(data, resolve) {
      var i;

      // Trava para não redirecionar em sites de parceiros
      if (window.location.hostname.indexOf('memed.com.br') === -1) {
        resolve();
        return;
      }

      for (i in data) {
        if (Object.prototype.hasOwnProperty.call(data, i)) {
          window.location[i] = data[i];
        }
      }

      resolve();
    });

    // Define o location hash da janela principal
    MdHub.command.add('core:setLocationHash', function setLocationHash(data, resolve) {
      // Trava para não alterar em sites de parceiros
      if (window.location.hostname.indexOf('memed.com.br') === -1) {
        resolve();
        return;
      }

      window.location.hash = data;
      resolve();
    });

    // Aplica os estilos customizados por módulo
    MdHub.command.add('core:updateModuleStyle', function updateModuleStyle(data, resolve) {
      MdHub.module.updateStyle(data);
      resolve();
    });

    /**
     * Atualiza as opções globais para customização de módulos
     *
     * @param  {Object} data Objeto com informações do nome do módulo e estilos
     * Exemplo:
     * module = 'prescricao'
     * data = {
     *   fullscreen:   true,
     *   primaryColor: '#576cff',
     *   minWidth:     '810px'
     * }
     */
    MdHub.command.add('core:setOptionsCustom', function setOptionsCustom(module, data, resolve) {
      var moduleName = module;

      if (Boolean(module) === false) {
        moduleName = 'global';
      }

      this.optionsCustom[moduleName] = data;
      resolve();
    });

    /**
     * Retorna as opções globais para customização de módulos
     *
     * @returns {Object} Objeto com opções do módulo
     *
     * Exemplo:
     * {
     *    fullscreen:   true,
     *    primaryColor: '#576cff',
     *    minWidth:     '810px'
     * }
     */
    MdHub.command.add('core:getOptionsCustom', function getOptionsCustom(module, resolve) {
      var moduleName = module;

      if (Boolean(module) === false) {
        moduleName = 'global';
      }

      resolve(MdHub.optionsCustom[moduleName]);
    });

    /**
     * Alterna o valor da propriedade 'position' entre 'relative' e 'absolute'
     *
     * @returns {Object} Objeto com opções do módulo
     */
    MdHub.command.add('core:setIframeContainerPosition', function setIframeContainerPosition(position) {
      var iframeContainer;
      if (MdHub.optionsCustom.global.fullscreen === false) {
        iframeContainer = document.querySelector('#iframe-container');
        iframeContainer.style.position = position;
      }
    });

    /**
     * Ao adicionar um item à prescrição, a altura da div "data-container" é atualizada
     * de acordo com a altura retornada pelo módulo 'plataforma.prescricao'.
     */
    MdHub.event.add('medicamentoAdicionado', function medicamentoAdicionado() {
      MdHub.event.trigger('prescricaoAtualizada');
    });

    /**
     * Ao remover um item da prescrição, a altura da div "data-container" é atualizada
     * de acordo com a altura retornada pelo módulo 'plataforma.prescricao'.
     */
    MdHub.event.add('medicamentoRemovido', function medicamentoRemovido() {
      MdHub.event.trigger('prescricaoAtualizada');
    });

    /**
     * Ao atualizarmos a prescrição (adicionando um novo item, modificando
     * a posologia de um item, etc.)
     *
     */
    MdHub.event.add('prescricaoAtualizada', function prescricaoAtualizada() {
      if (MdHub.optionsCustom.global.fullscreen === false) {
        document.querySelector('body').style.overflow = 'auto';
        MdHub.command.send('plataforma.prescricao', 'getHeightOfCanvasPrescription').then(function callbackHeightCanvas(height) {
          document.querySelector('#' + MdHub.optionsCustom.global.container).style.height = height + 'px';
        });
      }
    });

    /**
    * Define o tamanho da div container, baseado em um evento disparado pelos filhos
    * Atualmente utilizado no formulário de alto custo.
     */
    MdHub.event.add('updateHeightContainer', function updateHeightContainer(heightForm) {
      document.querySelector('body').style.overflow = 'auto';
      document.querySelector('#' + MdHub.optionsCustom.global.container).style.height = heightForm;
    });
  },

  /**
  * Deixa de escutar o evento message e hashChange do modo Server.
  */
  unbindEvents: function unbindEvents() {
    window.removeEventListener('message', this.registerEventMessage, false);
    window.removeEventListener('hashchange', this.registerEventHashchange, false);
  },

  /**
   * Inicializa uma instância do MdHub Server
   * @param  {Object} options Opções de inicialização
   * Exemplo: {
   *    apiKey: 'Chave da aplicação que inicializara o MdHub',
   *    container: 'Id do elemento contentor da app Memed',
   *    button: true, // Definição de botão da prescrição
   *    modules: ['prescricao', 'catalogo', 'usuario']// Lista de módulos requeridos pela aplicação
   *  }
   *
   */
  init: function init(options) {
    var body;
    var div;
    var i;
    var iframeContainer;
    /*
    O position deve se manter como absolute pois afeta
    as integracoes de parceiro sem data-container
    definido e o login em ambiente sandbox.
    */
    var iframeContainerPosition = 'absolute';
    var modulePosition;
    var script;
    var height;

    MdHub.optionsCustom = {
      global: {
        fullscreen: true,
        primaryColor: '#576cff'
      }
    };

    // Disponibiliza as environments
    MdHub.getEnvironments();

    // Procura nos scripts do documento quem é o plataforma.hub.min.js
    for (i in document.scripts) {
      if (Object.prototype.hasOwnProperty.call(document.scripts, i)) {
        script = document.scripts[i].src;

        // Caso já exista um script do hub adicionado a página
        if (script && script.indexOf('plataforma.hub') > 0) {
          script = script.replace('http://', '').replace('https://', '').replace('//', '').replace('plataforma.', '')
            .split('/');
          MdHub.domain = script[0];

          break;
        }
      }
    }

    // Se não possuir um container adicionado a página, cria um
    if (!options.container || !document.getElementById(options.container)) {
      // console.warn('O container definido não foi encontrado na DOM,
      // adicionando div#memed-auto-generated como substituto');

      div = document.createElement('DIV');
      div.setAttribute('id', 'memed-auto-generated');
      // Inicializa o container escondido.
      div.style.display = 'none';

      body = document.getElementsByTagName('body')[0];
      body.appendChild(div);
      // Mantido para retrocompatibilidade
      // eslint-disable-next-line no-param-reassign
      options.container = 'memed-auto-generated';
    } else {
      div = document.getElementById(options.container);
    }

    // Quando for definida a variável container, definir container com position:relative,
    // para que os iframes com position:absolute considerem ela (ao invés do body).
    if (options.container !== 'memed-auto-generated' && options.container !== 'memed') {
      iframeContainerPosition = 'relative';
      MdHub.optionsCustom.global.fullscreen = false;
    }

    if (options.styles && options.styles.primaryColor) {
      MdHub.optionsCustom.global.primaryColor = options.styles.primaryColor;
    }

    MdHub.optionsCustom.global.container = options.container;

    iframeContainer = document.createElement('DIV');
    iframeContainer.setAttribute('id', 'iframe-container');
    iframeContainer.style.display = 'none';
    iframeContainer.style.position = options.styles && options.styles.position
      ? options.styles.position
      : iframeContainerPosition;
    iframeContainer.style.top = '0';
    iframeContainer.style.right = '0';
    iframeContainer.style.bottom = '0';
    iframeContainer.style.left = '0';
    iframeContainer.style.height = options.styles && options.styles.height ? options.styles.height : '100%';

    div.appendChild(iframeContainer);

    MdHub.module.name = 'hub';
    MdHub.module.build = options.build;
    MdHub.module.require = options.require || {};
    MdHub.module.version = options.version;
    MdHub.options = options;
    MdHub.mode = 'server';

    this.bindEvents();

    if (MdHub.optionsCustom.global.fullscreen === false && !options.noDefaultHeight) {
      // Define o tamanho ideal para o inicio do canvas da prescricao.
      // Não garantimos que o parceiro define o tamanho inicial para o container.
      height = document.getElementById(MdHub.optionsCustom.global.container).offsetHeight;

      if (!height || height < 700) {
        height = 700;
      }

      document.querySelector('#' + MdHub.optionsCustom.global.container).style.height = height + 'px';
    }

    // Inicia a chamada de criação dos módulos
    for (i in options.modules) {
      if (Object.prototype.hasOwnProperty.call(options.modules, i)) {
        MdHub.module.add(options.modules[i]);

        switch (options.modules[i]) {
          case 'synapse.alert':
            modulePosition = 'absolute';
            break;
          case 'plataforma.medicamento':
            modulePosition = 'absolute';
            break;
          default:
            modulePosition = 'static';
            break;
        }

        if (MdHub.optionsCustom.global.fullscreen === false) {
          MdHub.module.updateStyle({
            moduleName: options.modules[i],
            styles: {
              position: modulePosition
            }
          });
        }
      }
    }
  }
};
